<template>
    <div class="componentsCtn_1">
        <div class="left">
            <pl-lazy>
              <main-map
                ref="mainMap"
                :lyrdata="lyrdata"
                :mapParams="mapParams"
                :showSearchBar="false"
              >
              </main-map>
            </pl-lazy>
            <div class="return-button" @click="returnAuditor" >返回列表</div>
        </div>
        <div class="right">
            <!-- 查询区 -->
            <div class="search">
                <div class="item">
                    <div class="item-name" style="width: 50px;">编号：</div>
                    <a-input placeholder="请输入编号" v-model="idReq" @keydown="keyDown()" style="width:165px"></a-input>
                </div>
                <div class="item">
                    <div class="item-name">所属区：</div>
                    <a-input placeholder="请输入所属区" v-model="countyReq" @keydown="keyDown()" style="width:135px"></a-input>
                </div>
                <div class="item">
                    <div class="item-name">审核状态：</div>
                    <a-select placeholder="请选择审核状态" v-model="statusReq" style="width:135px;">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="false">未审核</a-select-option>
                        <a-select-option value="true">已审核</a-select-option>
                    </a-select>
                </div>
                <div class="item">
                    <div class="item-name"  style="width: 50px;"> 类型：</div>
                    <a-select placeholder="请选择类型" v-model="typeReq" style="width:165px;">
                        <a-select-option v-for="(t, index) in typeList" :value="t" :key="index">{{ t }}</a-select-option>
                    
                    </a-select>
                </div>
                <div class="item">
                    <div class="item-name">年份期数：</div>
                    <a-select placeholder="年份期数" v-model="yearReq" style="width:135px">
                        <a-select-option v-for="(y, index) in yearList" :value="y" :key="index">{{ y }}</a-select-option>
                    </a-select>
                </div>
                <div class="search-button">
                    <a-button type="primary" html-type="submit" @click="search"><img src="@/assets/查询.png"
                            style="width:19px; line-height:32px"><span style="width:5px;"></span> 查询 </a-button>
                    <a-button type="primary" style="margin-left: 20px" @click="resetSearch"><img src="@/assets/重置.png"
                            style="width:14px; line-height:32px"><span style="width:8px;"></span> 重置</a-button>
                </div>
            </div>
            <!-- 表格区 -->
            <div class="table">
                <a-config-provider :locale="locale">
                    <a-table :columns="tableColumns" :data-source="tableData" :pagination="ipagination" :customRow="rowClick"
                         @change="handleTableChange">
                         <span slot="examineStatus" slot-scope="text, record">
                            <span v-if="record.examineStatus == 'true'"> 已审核 </span>
                            <span v-if="record.examineStatus == 'false'"> 未审核 </span>
                        </span>
                        <span slot="action" slot-scope="text, record">
                            <a @click="showDetail(record)" style="color: #1890ff;">
                                <span v-if="record.examineStatus == 'true'"> 查看 </span>
                                <span v-if="record.examineStatus == 'false'"> 审核 </span>
                            </a>
                        </span>
                    </a-table>
                </a-config-provider>
            </div>
            
        </div>
        <!-- 详情展示 -->
        <div class="detail" v-if="detailBox" >
            <a-card title="审 核 " :bordered="false" style="width: 780px" :headStyle="{'textAlign': 'center','fontSize':'18px','fontWeight':'600'}">
                <img class="detail-close"  src="../../assets/images/关闭.png" alt="" @click="detailBox = false">
                <div class="detail-item">
                    <span class="detail-name">地块编号：{{ detailPointName }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-name">所属省：{{ detailProvince }}</span>
                    <span class="detail-name">所属市：{{ detailCity }}</span>
                    <span class="detail-name">所属区：{{ detailCounty }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-name">所属部门：{{ detailDepart }}</span>
                    <span class="detail-name">经度：{{ detaiLongitude }}</span>
                    <span class="detail-name">纬度：{{ detailLatitude }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-name">核查员：{{ detailCheckUserName }}</span>
                    <span class="detail-name">核查员联系方式：{{ detailCheckUserPhone }}</span>
                    <span class="detail-name">核查日期：{{ detailCheckTime }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-name">备注：{{ detailRemark }}</span>
                </div>
                <!-- 核查图片 -->
                <a-divider orientation="center" >核查图片</a-divider>
                <div class="img-list">
                    <viewer :images="imgList" class="screen-view"  @click="show">
                        <img v-for="(url,index) in imgList" :key="index" :src="url" alt="">
                    </viewer>
                </div>
                <!-- 审核结果 -->
                <a-divider orientation="center">审核结果</a-divider>
                <div class="examine">
                    <a-radio-group v-model="detailStatus" >
                        <a-radio :value="46">销号归档：<span class="examine-text">(经核查，不存在问题或问题已解决，销号处理)</span></a-radio>
                        <a-radio :value="41" style="padding-top: 5px;">重新核查：<span class="examine-text">(核查信息填报有误或图片位置内容与实际不符)</span></a-radio>
                    </a-radio-group>
                    <a-input v-if="detailStatus == 41" v-model="detailExamineRemark" placeholder="请输入理由" allow-clear style="padding-top: 10px;"/>
                    <div class="examine-button">
                        <div :class="buttonClassPass" @click="examineResult(46)">销号归档</div>
                        <div :class="buttonClassReturn" @click = "examineResult(41)">重新核查（退回）</div>
                    </div>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import MainMap from '@/components/Maps/MainMap'
import { drawerControl } from '@/components/Maps/drawerControl'
import { Vector as lVector, VectorTile as lVectorTile  } from 'ol/layer'
import { Style, Fill, Stroke, Text, Circle as CircleStyle, Icon } from 'ol/style'
import { WKT as fmtWKT, GeoJSON } from 'ol/format';
import VectorSource from 'ol/source/Vector'
import { createEmpty, extend } from 'ol/extent'
import { transform, transformExtent } from "ol/proj";
import Feature from 'ol/Feature'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
Vue.use(VueViewer)

export default {
    name: "examine",
    mixins: [drawerControl],
    components: {
        MainMap,
    },
    data() {
        return {
            taskId:"1b2df32c175c4f79957a49350f1da379",
            /* 查询 */
            idReq: "",
            statusReq: "",
            countyReq: "",
            yearReq: "",
            typeReq:"",
            countyList: ["长光", "卫星", "技术"],
            yearList: ["2021", "2022", "2023"],
            typeList:[],
            /* 表格 */
            tableColumns: [
                {
                    title: '序号',
                    dataIndex: 'key',
                    key: 'key',
                    width: 25,
                    align: 'center'
                },
                {
                    title: '地块编号',
                    width: 70,
                    dataIndex: 'pointName',
                    key: 'pointName',
                    align: 'center'

                },{
                    title: '所属区',
                    dataIndex: 'county',
                    key: 'county',
                    width: 65,
                    scopedSlots: { customRender: 'county' },
                    align: 'center'

                },
                {
                    title: '审核状态',
                    dataIndex: 'examineStatus',
                    key: 'examineStatus',
                    width: 65,
                    scopedSlots: { customRender: 'examineStatus' },
                    align: 'center'

                },
                {
                    title: '类型',
                    dataIndex: 'type',
                    key: 'type',
                    width: 65,
                    scopedSlots: { customRender: 'type' },
                    align: 'center'

                },
                {
                    title: '影像时间',
                    dataIndex: 'imageDate',
                    key: 'imageDate',
                    width: 65,
                    scopedSlots: { customRender: 'imageDate' },
                    align: 'center'

                },
                {
                    title: '操作',
                    key: 'action',
                    width: 25,
                    scopedSlots: { customRender: 'action' },
                    align: 'center'

                },
            ],
            tableData: [],
            // tableData,
            tableDataAudit: [],
            /* 分页参数 */
            ipagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50','100'],
                showTotal: (total, range) => {
                    return " 共" + total + "条"
                    // return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            locale: zhCN,
            /* 排序参数 */
            isorter: {
                column: 'createTime',
                order: 'desc',
            },
            /* 详情 */
            detailBox: false,//任务详情
            detailId : "",
            detailPointName:"",
            detailExamineStatus: false,
            detailProvince:"",
            detailCity:"",
            detailCounty:"",
            detailDepart:"",
            detaiLongitude:"",//经度
            detailLatitude:"",//纬度
            detailCheckTime:"",
            detailCheckUserName:"",
            detailCheckUserPhone:"",
            imgList:[],
            detailStatus: 46,
            detailRemark:"",
            detailExamineRemark:"",
            buttonClassPass: ['button','active'],
            buttonClassReturn: ['button','return'],

            lyrdata: [
                //【图层组】天地图服务
                {
                    lyrType: "Group",
                    //srcType:"Group",
                    mTitle: "天地图服务",
                    mVisible: true,
                    mSubLayers: [
                        //天地图路网
                        {
                            lyrType: "Tile",
                            srcType: "XYZ",
                            mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
                            mTitle: "路网",
                            mName: "路网",
                            mVisible: true
                        },
                        //天地图卫星影像
                        {
                            lyrType: "Tile",
                            srcType: "XYZ",
                            mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
                            mTitle: "卫星",
                            mName: "卫星",
                            mVisible: false
                        },
                    ],
                },
                {
                    lyrType: "Tile",
                    srcType: "XYZ",
                    mUrl: "https://api.jl1mall.com/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=0073bef5c4266498b8f18225fe63a3fa&vf=0",
                    mTitle: "卫星",
                    mName: "卫星",
                    mVisible: true
                },
                //天地图文字标注
                {
                    lyrType: "Tile",
                    srcType: "XYZ",
                    mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
                    mTitle: "文字标注",
                    mName: "文字标注",
                    mVisible: false
                },
                {
                    lyrType: "lVector",
                    srcType: "Vector",
                    mUrl: "",
                    mTitle: "核查地块",
                    mName: "核查地块",
                    mVisible: true
                },
            ],
            mapParams: {
                projection: 'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
                center: [125.42174, 43.68], //地图初始化时的中心坐标【基于4326坐标系】
                minZoom: 5, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
                maxZoom: 20, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
                zoom: 10.8, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
            },
            fullScreen: false,
            featureLayer:{},

        }
    },
    methods: {
        show() {
          this.$viewerApi({
            images: this.imageList
          })
        },
        returnAuditor(){
            this.$router.push({path:'/auditor',query:{taskId:this.taskId}})
        },
        search() {
            this.loadData()
        },
        resetSearch() {
            this.idReq = ''
            this.statusReq = ''
            this.yearReq = ''
            this.countyReq = ''
            this.typeReq = ''
            this.ipagination.current = 1
            this.loadData()
        },
        //显示我的任务，任务详情（协同标注）
        showDetail: function (record) {
            this.detailBox = true;
            this.getimgList(record.pointSequence);
            this.detailId = record.id;
            this.detailPointName = record.pointName;
            this.detailExamineStatus = record.examineStatus;
            this.detailProvince = record.province;
            this.detailCity = record.city;
            this.detailCounty = record.county;
            this.detailDepart = record.depart;
            this.detailLongitude = record.longitude;
            this.detailLatitude = record.latitude;
            this.detailCheckTime = record.checkTime;
            this.detailCheckUserName = record.checkUserName;
            this.detailCheckUserPhone = record.checkUserPhone;
            this.detailRemark = record.remark;
            this.detailExamineRemark = record.examineRemark;
        },
        examineResult(result){
            if(this.detailStatus == result){
                let param = new FormData();
                param.append("taskId",this.taskId)
                param.append("status",result)
                param.append("pointId",this.detailId)
                param.append("remark",this.detailExamineRemark)
                this.axios({
                    method: 'post',
                    url: '/tilesapi/tiles/task/field/point/updateCheckExamineStatus',
                    // params: {
                    //     "taskId": this.taskId, //任务id
                    //     "status": result, //审核状态，41重新核查，46核查审核通过(销号归档);环保系统都用的这些状态表示
                    //     "pointId": this.detailId, //点位id，对应列表中的id
                    //     "remark": this.detailExamineRemark //备注
                    // },
                    data:{
                        "taskId": this.taskId, //任务id
                        "status": result, //审核状态，41重新核查，46核查审核通过(销号归档);环保系统都用的这些状态表示
                        "pointId": this.detailId, //点位id，对应列表中的id
                        "remark": this.detailExamineRemark //备注
                    },
                    headers: {
                        Authorization: "Bearer " + this.getKey(),
                    },
                }).then((response) => {
                    if(response.data.msg == '操作成功'){
                        this.$message.success("已审核")
                        this.detailBox = false;
                        this.loadData()
                    }
                })
            }
        },
        getKey() {
            return localStorage.getItem("token");
        },
        handleTableChange(pagination, filters, sorter) {
            //分页、排序、筛选变化时触发
            //TODO 筛选
            if (Object.keys(sorter).length > 0) {
                this.isorter.column = sorter.field;
                this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
            }
            this.ipagination = pagination;
            this.loadData();
        },
        loadData() {
            //外业核查图斑列表
            this.axios({
                method: 'get',
                url: '/tilesapi/tiles/task/field/point/queryPointList',
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
                params: {
                    pageNo: this.ipagination.current,
                    pageSize: this.ipagination.pageSize,
                    taskId: this.taskId,
                    pointName: this.idReq,
                    examineStatus: this.statusReq,
                    period: this.yearReq,
                    county: this.countyReq,
                    type:this.typeReq
                }
            }).then((response) => {
                let records = response.data.data.records
                this.tableData = []
                this.ipagination.total = response.data.data.total
                let features=[]
                for(let i = 0; i < records.length;i++){
                    this.tableData.push({
                        key: i+1,
                        id: records[i].id, //图斑id
                        pointName : records[i].pointName,
                        type: records[i].type,
                        county: records[i].county,
                        examineStatus: records[i].examineStatus,
                        imageDate: records[i].imageDate,
                        province: records[i].province,
                        city: records[i].city,
                        depart: records[i].depart,
                        longitude: records[i].longitude,
                        latitude: records[i].latitude,
                        checkUserName: records[i].checkUserName,
                        checkUserPhone: records[i].checkUserPhone,
                        checkTime: records[i].checkTime,
                        remark: records[i].remark,
                        examineRemark: records[i].examineRemark,
                        pointSequence:records[i].pointSequence,
                    })
                    const format = new fmtWKT()
                    var polygon = format.readFeatureFromText(records[i].shape, {
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857',
                    }).getGeometry();
                    let feature = new Feature({
                        geometry: polygon,
                        examineStatus:records[i].examineStatus,
                    })
                    features.push(feature)
                }
                let source = new VectorSource({
                    features:features
                })
                let allLayers = this.$refs.mainMap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
                allLayers.forEach(layer => {
                    if (layer instanceof lVector && layer.values_.title=='核查地块'){
                        layer.getSource().clear()
                        layer.setSource(source)
                        var numFeatures = source.getFeatures();
                        let extent = createEmpty()  //生成数据范围
                        for (let i = numFeatures.length - 1; i >= 0; --i) {
                            let feature = numFeatures[i]
                            extend(extent, feature.getGeometry().getExtent())
                        }
                        this.$refs.mainMap.map.getView().fit(extent) //跳转地图视角到数据范围中
                        this.featureLayer=layer
                    }
                })
                this.refreshStyle()
            }) 
        },
        getYearList(){
            this.axios({
                method: 'get',
                url: '/tilesapi/tiles/task/field/point/queryPointPeriodList?taskId=' + this.taskId,
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
            }).then((response) => {
                this.yearList = response.data.data
            })
        },
        getTypeList(){
            this.axios({
                method: 'get',
                url: '/tilesapi/tiles/task/field/point/queryPointTypeList?taskId=' + this.taskId,
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
            }).then((response) => {
                this.typeList = response.data.data
            })
        },
        getimgList(id){
            this.axios({
                method: 'post',
                url: '/tilesapi/oss/file/queryByBusinessId',
                params: {
                    businessId : id, // 图斑id
                },
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
            }).then((response) => {
                if(response.data.msg == "操作成功"){
                    let newData = response.data.data
                    this.imgList = []
                    for(let i = 0; i < newData.length;i++){
                        this.imgList.push(newData[i].url)
                    }

                }
            })
        },
        //点击后跳转到指定地块位置并选中
        zoomToPlace(record){
            let center = transform([record.longitude, record.latitude], 'EPSG:4326', 'EPSG:3857')
            let features=this.featureLayer.getSource().getFeaturesAtCoordinate(center)
            if (features.length > 0) {
                //重置颜色
                this.refreshStyle()
                //设置颜色
                features[0].setStyle(
                    new Style({
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 0)' //填充颜色
                        }),
                        stroke: new Stroke({
                            color: '#66ccff', //边框颜色
                            width: 2 // 边框宽度
                        }),
                        image: new CircleStyle({
                            radius: 7,
                            fill: new Fill({
                                color: '#66ccff'
                            })
                        })
                    })
                );
            }
            this.$refs.mainMap.map.getView().setCenter(center)
            this.$refs.mainMap.map.getView().setZoom(17)
        },
        refreshStyle(){
            let features = this.featureLayer.getSource().getFeatures()
            let color
            features.forEach(feature => {
                if (feature.getProperties()["examineStatus"] == 'true') color = '#66ccff'
                else color = '#ffcc33'
                feature.setStyle(
                    new Style({
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 0)' //填充颜色
                        }),
                        stroke: new Stroke({
                            color: color, //边框颜色
                            width: 2 // 边框宽度
                        }),
                        image: new CircleStyle({
                            radius: 7,
                            fill: new Fill({
                                color: color
                            })
                        })
                    })
                )
            });
        },
        rowClick(record, index) {
            return {
                on: {
                    click: () => {
                        this.zoomToPlace(record)
                    }
                }
            }
        }
    },
    mounted() {
        this.taskId = this.$route.query.taskId
        this.getYearList()//获取图斑年份期数筛选列表
        this.loadData()
        this.getTypeList()

    },
    watch:{
        detailStatus(){
            if(this.detailStatus == 46){
                this.buttonClassPass = ['button','active']
                this.buttonClassReturn = ['button','return']
            }else if(this.detailStatus == 41){
                this.buttonClassPass = ['button','return']
                this.buttonClassReturn = ['button','active']
            }
        },
        typeReq(){
            this.loadData()
        },
        statusReq(){
            this.loadData()
        },
        yearReq(){
            this.loadData()
        },
    }
}
</script>

<style scoped lang="scss">
::v-deep .ant-table-thead>tr>th {

    font-weight: 700;
}

// ::v-deep .ant-select-selector { min-width: 179px; }
::v-deep .ant-col {
    height: 50px;
}

.componentsCtn_1 {
    // min-width: 1912px;
    width: 100%;
    height: calc(100% - 76px);
    margin-top: 76px;
    overflow: scroll;
    position: relative;


    .left {
        width: 61%;
        height: 100%;
        display: inline-block;
        vertical-align: top;
        position: relative;

        .return-button {
            display: inline-block;
            text-align: center;
            width: 101px;
            height: 37px;
            line-height: 37px;
            background: #0091FF;
            border-radius: 8px;
            font-size: 15px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            position: absolute;
            top: 40px;
            left: 28px;
            cursor: pointer;
        }
    }

    .right {
        width: 39%;
        min-width: 740px;
        box-sizing: border-box;
        height: calc(100% - 5px);
        padding: 20px;
        padding-top: 50px;
        display: inline-block;
        position: absolute;
        vertical-align: top;
        top: 0;
        left: 61%;
        .search div {
            display: inline-block;
        }

        .search {
            .item {
                padding: 8px 10px;
                box-sizing: border-box;

                .item-name {
                    width: 75px;
                }
            }

            .search-button {
                padding: 8px;
            }
        }
        

    }
    .detail{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            background: rgba(236,236,236,.5); 
            padding-left: calc(50% - 390px);
            padding-top: 10%;
            .detail-close{
                position: absolute;
                top:21px;
                right:20px;
                cursor: pointer;

            }
            .detail-item{
                .detail-name{
                    display: inline-block;
                    width: 240px;
                    height: 25px;
                    line-height: 25px;
                }
            }
            .img-list img{
                height: 100px;
                padding-right: 20px;
                cursor: pointer;
            }
            .examine{
                .examine-text{
                    color: red;
                }
                .examine-button{
                    margin-top: 15px;
                    text-align: center;
                    .button{
                        display: inline-block;
                        border-radius: 5px;
                        padding: 5px 15px;
                        margin: 0 10px;
                        
                    }
                    .active{
                        background-color: #0091FF;
                        color: #FFFFFF;
                        border: 1px solid #0091FF;
                        cursor: pointer;
                    }
                    .return{
                        background-color: #f5f5f5;
                        color: #c3c3c3;
                        border: 1px solid #e1e1e1;
                    }
                }
                
            }
        }
}
</style>